import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        this.setVisuals();
    }

    private static setVisuals() {
        const visuals = new (<any>window).Swiper(".swiper-container", {
            modules: [(<any>window).Autoplay, (<any>window).Lazy, (<any>window).Pagination, (<any>window).A11y],
            loop: true,
            preloadImages: false,
            lazy: {
                loadOnTransitionStart: true,
                loadPrevNext: true
            },
            autoplay: {
                delay: 4000
            },
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
                renderBullet: function (index, className) {
                    return "<button class=" + className + ">" + (<any>window).App.bag.Visuals[index].title.replace("|", " ").replace("|", " ") + "</button>";
                }
            }
        });
    }
}